module.exports = __webpack_public_path__ + "static/scale-model-of-audubon-north-carolina-in-durham-north-carolina-1cf653a7dc6fe2289b27988c942cc9af.png";